/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 화면 전체를 덮는 컴포넌트
 * 버전 : 1.0
 * 파일명 : ExtraCoverStyles.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-18
 * ================================================================ 
 * ================================================================ */


import styled from "styled-components";

export const ExtraCoverWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 401;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
`

// 사용하지 않더라도 반드시 좌,우측 더미 클래스를 지정해줘야 가운데 정렬이 됨
// **사용예시**
// <ExtraCoverHeader>
//     <div className="left" onClick={() => setField("isCoverdBy", null)}>
//         <Icon_ArrowBack />
//     </div>
//     <span className='title'>
//         관심 표명자 명단 업로드
//     </span>
//     <div className="right" />
// </ExtraCoverHeader>
export const ExtraCoverHeader = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;

    padding: 10px 20px;
    max-height: 56px;

    font-size: 18px;
    font-weight: bold;

    .left {
        justify-self: start;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .title {
        justify-self: center;
        text-align: center;
    }

    .right {
        justify-self: end;
        width: 24px;
        height: 24px;
    }
`;

export const ExtraCoverContent = styled.div`
    padding: 20px;
    height: calc(100vh - 82px - 44px);
    overflow-y: auto;
`